import React, { useState } from "react";
import PageBanner from "../components/PageBanner";
import Sidebar from "../components/Sidebar";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { FAQ_NATUROPATHIC, FAQ_CHINESE, PAGE_BANNERS } from "../data/content";

export default function FAQ() {
  const [tab, setTab] = useState("naturopathic");
  const items = tab === "naturopathic" ? FAQ_NATUROPATHIC : FAQ_CHINESE;
  return (
    <div>
      <PageBanner src={PAGE_BANNERS.clinic} alt="FAQ" fallbackKey="clinic" />
      <div className="flex flex-col lg:flex-row gap-8">
        <Sidebar />
        <article className="flex-1 nn-content">
          <h1>Frequently Asked Questions</h1>
          <div className="flex gap-2 mb-6 border-b border-[#d6dcb6]">
            <button
              onClick={() => setTab("naturopathic")}
              className={`px-4 py-2 font-display tracking-wide ${
                tab === "naturopathic"
                  ? "bg-[#8da55f] text-white"
                  : "text-[#7d8e54] hover:bg-[#f6f8ec]"
              }`}
            >
              Naturopathic Medicine
            </button>
            <button
              onClick={() => setTab("chinese")}
              className={`px-4 py-2 font-display tracking-wide ${
                tab === "chinese"
                  ? "bg-[#8da55f] text-white"
                  : "text-[#7d8e54] hover:bg-[#f6f8ec]"
              }`}
            >
              Chinese Medicine
            </button>
          </div>
          <Accordion type="single" collapsible className="w-full">
            {items.map((it) => (
              <AccordionItem key={it.q} value={it.q} className="border-b border-[#d6dcb6]">
                <AccordionTrigger className="text-left font-display text-[#5b6a37] hover:text-[#5b6a37] text-base">
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#4a4a3d] leading-relaxed">{it.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </article>
      </div>
    </div>
  );
}
